<app-confirm-popup *ngIf="showModal" [title]="modalButton" [message]="modalMessage" [confirmText]="modalButton"
  [triggerModal]="showModal" [cancelText]="'Cancel'" (confirm)="onConfirm(modalButton)"
  (cancel)="showModal =false;selectedCatalogId = ''"></app-confirm-popup>
<div class="sub-header px-3">
</div>
<div class="search-container align-items-center d-flex row px-3 mb-0 pb-4">
  <h4 class="col-md-5 mb-0"> Catalog Overview</h4>
  <div class="col-md-7 search-input-block d-flex align-items-center justify-content-around">
    <nz-input-group class="px-2 search-input-group" style="width: 60%;" nzSize="default" [nzSuffix]="suffixIconSearch">
      <input nz-tooltip type="text" class="py-1" nz-input placeholder="Search catalogs by Name or EDP/AR #" 
    [nzTooltipTitle]="'Search catalogs by Name or EDP/AR #'"
        (keydown.enter)="filterCatalog(SearchText.value)" [(ngModel)]="searchText"
        (ngModelChange)="filterCatalog(SearchText.value)"  nzAllowClear #SearchText />
      <span class="close-icon" (click)="SearchText.value = '';filterCatalog('')" class="px-1" nz-icon
        nzType="close-circle"></span>
    </nz-input-group>
    <ng-template #suffixIconSearch>
      <span class="search-icon" (click)="filterCatalog(SearchText.value)" nz-icon nzType="search"></span>
    </ng-template>

    <button nz-button class="d-flex justify-content-center pad-7" (click)="sortCatalog()">
      <img  [src]="sortDirAsc ? 'sort-ascending.svg': 'sort-descending.svg'" class="anticon custom-menu-img" alt="" />
    </button>
    <button [disabled]="!authService.webAdm" (click)="addCatalogVisible = !addCatalogVisible" nz-button nzType="primary"
      class="d-flex align-items-center" [nzSize]="'default'">
      <span nz-icon nzType="plus"></span>New Catalog
    </button>
  </div>
</div>
<div class="catalog-options-wrapper row px-2">
  <ul class="nav col-md-9">
    @for(item of catalogStatus;track item.id) {
    <li class="nav-item">
      <a (click)="handleTab(item); filterCatalogList();" [ngClass]="item.clicked ? 'active-tab' : ''"
        class="nav-link active">{{item.name}}</a>
    </li>
    }
  </ul>
  <div class="col-md-3 d-flex justify-content-end">
    <button nz-tooltip="Migrate a catalog from the Old admin tool to the New"
      (click)="showMigrateModal = true;selectedOldCatalogId='';getOldCatalogs()" nz-button nzType="primary"
      class="d-flex align-items-center mr-10" [nzSize]="'default'" [disabled]="!authService.CCAdd">
      <span nz-icon nzType="interaction"></span>Migrate
    </button>
    <button nz-tooltip="Import a previously exported customer catalog file" (click)="showImportModal = true" nz-button
      nzType="primary" class="d-flex align-items-center mr-10" [nzSize]="'default'" [disabled]="!authService.CCAdd">
      <span nz-icon nzType="import"></span>Import
    </button>
  </div>
</div>
<app-spinner *ngIf="!dataLoaded"></app-spinner>
<div class="px-3" *ngIf="dataLoaded">
  <ng-container *ngIf="catalogData.length == 0">
    <div class="catalog-title mt-3 mb-3 py-1">
      No Catalogs found!
    </div>
  </ng-container>
  <cdk-virtual-scroll-viewport itemSize="catalogData.length" class="demo-infinite-container border-0">
    <div *cdkVirtualFor="let headerId of groupedHeaderList; trackBy: trackByIndex">
      <ng-container>
        <div class="catalog-title mt-3 mb-3 py-1">
          {{ headerId }}
        </div>
      </ng-container>
      <ng-container *ngFor="let category of displayCatalogData[headerId]; trackBy: trackByFn">
        <ul nz-list class="catalog-list" [nzDataSource]="catalogData" nzBordered nzSize="large">
          <li nz-list-item class="row">

            <div class="d-flex row catalog-box justify-content-center align-items-center">
              <div [routerLink]="['/catalog-manage', category['catalogId']]" (click)="redirect(category)"
                class="col-md-9 d-flex align-items-center">
                <nz-avatar [nzText]="category['catalogName'][0]"
                  style="color:#f56a00; background-color:#fde3cf;"></nz-avatar>
                <h6 class="my-custom-pointer w-90 text-break mb-0 px-3">{{ category['catalogName'] }}</h6>
              </div>
              <div class="col-md-3 d-flex align-items-center justify-content-end">
                @if(activeTab == 'Active'){
                <button *ngIf="enableMigrate(category['publishedFlag'])" (click)="publishCatalog(category['catalogId'])"
                  nz-button nzType="primary" class="d-flex align-items-center mr-10" [nzSize]="'default'"
                  nz-tooltip="Publish this catalog on the MOJO website">Publish
                </button>
                <button nz-button class="d-flex justify-content-center align-items-center">
                  <span (click)="$event.stopPropagation()" style="width: 20px;height: 20px;transform: rotate(90deg);"
                    nz-dropdown nz-icon nzTrigger="click" [nzType]="'ellipsis'" [nzDropdownMenu]="menu"></span>
                  <nz-dropdown-menu #menu="nzDropdownMenu">
                    <ul nz-menu class="category-options px-1 mt-1">
                      <li nz-tooltip="Export this catalog to a downloadable file" nz-menu-item
                         (click)="exportCatalog(category)" [nzDisabled]="!authService.CCAdd"> 
                        <!-- <i
                          class="dropdown-icon px-1" nz-icon [nzType]="'export'"></i>  -->
                          <img class="dropdown-icon px-0" [src]="'export.svg'"  />
                          Export
                      </li>
                      <li nz-menu-item (click)="deActivateCatalog(category)"> 
                        <!-- <i class="dropdown-icon px-1" nz-icon
                          [nzType]="'rest'"></i> -->
                          <img class="dropdown-icon px-0" [src]="'rest.svg'"  />Deactivate</li>
                      <li nz-menu-item (click)="deleteCatalog(category)" [nzDisabled]="!authService.CCDelete">
                        <!-- <i class="dropdown-icon px-1" nz-icon [nzType]="'delete'"></i> -->
                          <img class="dropdown-icon px-0" [src]="'delete.svg'"  />
                        Delete
                      </li>
                    </ul>
                  </nz-dropdown-menu>
                </button>
                }
                @if(activeTab == 'Inactive'){
                <button nz-button nzType="default" (click)="undoDeactiveCatalog(category['catalogId'])"
                  class="d-flex align-items-center mr-10" [nzSize]="'default'">Activate
                </button>
                }
              </div>
            </div>
          </li>
        </ul>
      </ng-container>
    </div>
  </cdk-virtual-scroll-viewport>
</div>



<nz-drawer [nzMaskClosable]="false" [nzKeyboard]="false" [nzWidth]="800" [nzVisible]="addCatalogVisible"
  nzTitle="Add Catalog" (nzOnClose)="close()" class="catalogAddDrawer">
  <ng-container *nzDrawerContent>
    <app-add-catalog (catalogSaveEvt)="addCatalogVisible = false;ngOnInit()"
      [catalogData]="originalCatalogData"></app-add-catalog>
  </ng-container>
</nz-drawer>
<nz-modal (nzOnOk)="showMigrateModal = false" [nzFooter]="modalFooter" (nzOnCancel)="showMigrateModal = false"
  [nzMaskClosable]="false" [nzClosable]="migrateStart ? false : true" nzCentered [nzWidth]="700"
  [(nzVisible)]="showMigrateModal" [nzBodyStyle]="{ overflowY: 'auto' }">
  <ng-container *nzModalContent>
    <div class="container d-flex flex-column px-4 py-3">
      <h5 class="mb-5 d-flex align-items-center">Select the Catalog to migrate</h5>
      <div class="col-md-12 row product-search-container p-0 mb-3 ml-5">
        <div class="col-md-10 mb-4 d-flex flex-column">
          <nz-select [nzDisabled]="migrateStart" nzPlaceHolder="Select" nzSize="default"
            [(ngModel)]="selectedOldCatalogId" [nzShowSearch]="true" style="height: 35px !important;">
            @for(catalog of oldCatalogData; track catalog){
            <nz-option [nzLabel]="catalog.catalogName" [nzValue]="catalog.catalogId"></nz-option>
            }
          </nz-select>
        </div>
      </div>
    </div>

  </ng-container>
  <ng-template #modalFooter>
    <button [disabled]="migrateStart" nz-button (click)="showMigrateModal = false" nzType="default">Cancel</button>
    <button nz-button nzType="primary" (click)="onConfirmMigrate()" [nzLoading]="migrateStart"
      [disabled]="!authService.CCAdd">{{ migrateStart ?
      "Migrating" : "Migrate" }}</button>
  </ng-template>
</nz-modal>
<nz-modal (nzOnOk)="showImportModal = false" [nzFooter]="importModalFooter" (nzOnCancel)="showImportModal = false;fileList = []"
  [nzMaskClosable]="false" nzCentered [nzWidth]="700" [(nzVisible)]="showImportModal" [nzClosable]="importStart ? false : true"
  [nzBodyStyle]="{ overflowY: 'auto' }">
  <ng-container *nzModalContent>
    <div class="container d-flex flex-column px-4 py-3">
      <h5 class="mb-5 d-flex align-items-center">Import Catalog</h5>
      <nz-upload nzType="drag" [(nzFileList)]="fileList" nzFileType="application/json"
        (nzChange)="handleChange($event)" [nzShowUploadList]="{ showRemoveIcon: importStart ? false : true }">
        <p class="ant-upload-drag-icon">
          <span nz-icon nzType="inbox"> </span>
        </p>
        <p class="ant-upload-text">Click or Drag a file to Import</p>
        <p class="ant-upload-hint" style="color: #ff4d4f; font-weight: 500;">
          * Only .json files are allowed for import.
        </p>
      </nz-upload>
    </div>
  </ng-container>
  <ng-template #importModalFooter>
    <button nz-button (click)="showImportModal = false;fileList = []" nzType="default">Cancel</button>
    <button nz-button nzType="primary"  [nzLoading]="importStart" (click)="onConfirmImport()"
      [disabled]="!authService.CCAdd || fileList.length == 0">{{ importStart ? "Importing" : "Import"
      }}</button>
  </ng-template>
</nz-modal>

<nz-modal (nzOnOk)="showDeleteModal = false" [nzFooter]="deleteModalFooter" (nzOnCancel)="showDeleteModal = false"
  [nzMaskClosable]="false" [nzClosable]="deleteStart ? false : true" nzCentered [nzWidth]="550"
  [(nzVisible)]="showDeleteModal" [nzBodyStyle]="{ overflowY: 'auto' }">
  <ng-container *nzModalContent>
    <div class="container custom-modal d-flex flex-column px-1 py-1">
      <div class="d-flex mb-3">
        <span class="quest-icon" nz-icon nzType="question-circle"></span>
        <b class="px-3">Delete</b>
      </div>
      <span class="content">
        Are you sure to delete <b>{{selectedCatalog}}</b> catalog permanently?
      </span>
    </div>

  </ng-container>
  <ng-template #deleteModalFooter>
    <button [disabled]="deleteStart" nz-button (click)="showDeleteModal = false" nzType="default">Cancel</button>
    <button nz-button nzType="primary" (click)="onConfirmDelete()" [nzLoading]="deleteStart"
      [disabled]="!authService.CCAdd">{{ deleteStart ?
      "Deleting" : "Delete" }}</button>
  </ng-template>
</nz-modal>